import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useRef, useState, } from 'react';
const DEFAULT_TIMEOUT = 10000;
const SnackBarContext = createContext({
    addMessage: () => { },
    removeMessage: () => { },
    previousMessageCount: 0,
    messages: [],
});
export const SnackBarProvider = ({ children, }) => {
    const [messages, setMessages] = useState([]);
    const removeMessageTimeouts = useRef([]);
    const previousMessageCount = useRef(0);
    const removeMessage = useCallback((id) => {
        setMessages((messages) => {
            previousMessageCount.current = messages.length;
            return messages.filter((m) => m.id !== id);
        });
    }, []);
    const addMessage = useCallback((message, options = {}) => {
        const newRandomId = Math.random().toString(36).substring(7);
        setMessages((messages) => {
            previousMessageCount.current = options.wipePrevious
                ? 0
                : messages.length;
            let newMessages = options.wipePrevious ? [] : [...messages];
            newMessages = newMessages.filter((m) => m.id !== message.id);
            newMessages.push(Object.assign(Object.assign({}, message), { id: message.id || newRandomId }));
            if (newMessages.length > 3) {
                newMessages.shift();
            }
            return newMessages;
        });
        const removeMessageTimeout = setTimeout(() => {
            removeMessage(newRandomId);
        }, options.timeout || DEFAULT_TIMEOUT);
        removeMessageTimeouts.current.push(removeMessageTimeout);
    }, [removeMessage]);
    useEffect(() => {
        return () => {
            removeMessageTimeouts.current.forEach((timeout) => clearTimeout(timeout));
        };
    }, []);
    return (_jsx(SnackBarContext.Provider, Object.assign({ value: {
            messages,
            removeMessage,
            previousMessageCount: previousMessageCount.current,
            addMessage,
        } }, { children: children })));
};
export const useSnackBar = () => {
    return useContext(SnackBarContext);
};
